import { ProductCenterRouteMap } from '@/new-router/product-center'

const Home = () => import('@/views/Home/home')

const DesktopManage = () => import('@/views/desktop/desktop-manage/desktop-manage')
const DesktopNode = () => import('@/views/desktop/desktop-node/desktop-node')
/**
 * hidden: true                   是否显示在侧栏上
 * meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
 **/

export default [
  {
    path: '/desktop',
    name: 'desktop',
    component: Home,
    meta: {
      title: '云制作管理',
      icon: 'icon-user',
      showSubiems: false,
      sort: 16,
      modules: 'desktop',
      permission: 'cloud:produce',
    },
    children: [
      {
        path: 'desktop-manage',
        name: 'desktop-manage',
        component: DesktopManage,
        meta: {
          title: '云制作管理列表',
          active: ['desktop-manage'],
          permission: 'cloud:produce:list',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.CloudProduction],
        },
      },
      {
        path: 'desktop-node',
        name: 'desktop-node',
        component: DesktopNode,
        meta: {
          title: '云制作机型管理',
          active: ['desktop-node'],
          permission: 'cloud:produce:model:list',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.CloudProduction],
        },
      },
    ],
  },
]
